import { spacing, colors } from '@mehilainen/mds-tokens';
import { baseTypography } from '@mehilainen/mds-tokens/typography';
import { alertClasses } from '@mui/material';
export const getThemeAlert = (tokens) => ({
    MuiAlert: {
        defaultProps: {
            iconMapping: tokens.uiElementAlert.icon.iconMapping,
            variant: 'standard',
        },
        styleOverrides: {
            root: {
                alignItems: 'center',
                border: tokens.uiElementAlert.border,
                borderRadius: tokens.uiElementAlert.borderRadius,
                fontSize: baseTypography.size[200].rem,
                fontWeight: baseTypography.weight.Regular,
                gap: spacing[500].rem,
                lineHeight: tokens.uiElementAlert.lineHeight,
                padding: tokens.uiElementAlert.padding,
            },
            icon: {
                alignItems: 'center',
                alignSelf: 'baseline',
                borderRadius: tokens.uiElementAlert.icon.borderRadius,
                flexShrink: 0,
                height: tokens.uiElementAlert.icon.bgHeight,
                justifyContent: 'center',
                marginRight: 0,
                opacity: 1,
                padding: 0,
                width: tokens.uiElementAlert.icon.bgWidth,
                '& > svg': {
                    fontSize: baseTypography.size.icon[300].rem,
                },
            },
            standard: ({ ownerState }) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                return ({
                    [`& > .${alertClasses.icon}`]: Object.assign({}, (ownerState.severity && {
                        backgroundColor: tokens.uiElementAlert.icon.standard.bgColor[ownerState.severity],
                        '& > svg': {
                            color: tokens.uiElementAlert.icon.standard.color[ownerState.severity],
                        },
                    })),
                    [`&.${alertClasses.colorError}`]: {
                        color: colors.Error600,
                        borderColor: (_b = (_a = tokens.uiElementAlert.borderColor) === null || _a === void 0 ? void 0 : _a.error) !== null && _b !== void 0 ? _b : colors.Error500,
                        backgroundColor: colors.Error100,
                    },
                    [`&.${alertClasses.colorInfo}`]: {
                        color: colors.Info600,
                        borderColor: (_d = (_c = tokens.uiElementAlert.borderColor) === null || _c === void 0 ? void 0 : _c.info) !== null && _d !== void 0 ? _d : colors.Info500,
                        backgroundColor: colors.Info100,
                    },
                    [`&.${alertClasses.colorSuccess}`]: {
                        color: colors.Success600,
                        borderColor: (_f = (_e = tokens.uiElementAlert.borderColor) === null || _e === void 0 ? void 0 : _e.success) !== null && _f !== void 0 ? _f : colors.Success500,
                        backgroundColor: colors.Success100,
                    },
                    [`&.${alertClasses.colorWarning}`]: {
                        color: colors.Warning600,
                        borderColor: (_h = (_g = tokens.uiElementAlert.borderColor) === null || _g === void 0 ? void 0 : _g.warning) !== null && _h !== void 0 ? _h : colors.Warning500,
                        backgroundColor: colors.Warning100,
                    },
                });
            },
            filled: ({ ownerState }) => ({
                color: colors.White,
                [`& > .${alertClasses.icon}`]: Object.assign({ backgroundColor: tokens.uiElementAlert.icon.filled.bgColor }, (ownerState.severity && {
                    '& > svg': {
                        color: tokens.uiElementAlert.icon.filled.color[ownerState.severity],
                    },
                })),
                [`&.${alertClasses.colorError}`]: {
                    borderColor: colors.Error500,
                    backgroundColor: colors.Error500,
                },
                [`&.${alertClasses.colorInfo}`]: {
                    borderColor: colors.Info500,
                    backgroundColor: colors.Info500,
                },
                [`&.${alertClasses.colorSuccess}`]: {
                    borderColor: colors.Success500,
                    backgroundColor: colors.Success500,
                },
                [`&.${alertClasses.colorWarning}`]: {
                    borderColor: colors.Warning500,
                    backgroundColor: colors.Warning500,
                },
            }),
            message: {
                padding: 0,
            },
            action: {
                alignSelf: 'flex-start',
                marginRight: 0,
                padding: 0,
            },
        },
    },
    MuiSnackbar: {
        defaultProps: {
            autoHideDuration: 3000,
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            },
        },
    },
    MuiAlertTitle: {
        styleOverrides: {
            root: {
                fontSize: baseTypography.size[300].rem,
                fontWeight: baseTypography.weight.Medium,
                lineHeight: baseTypography.height.Large,
                marginBottom: tokens.uiElementAlertTitle.marginBottom,
                marginTop: 0,
            },
        },
    },
});
